"use strict";

export function initInScope ($scope) {

    $scope.find('.js-video-control').on('click', function (evt) {
        evt.preventDefault();

        let $video = $(this).closest('.embed-responsive').find('video').get(0);

        if($video.paused) {
            $video.play();
            $(this).find('.icon-pause').removeAttr('hidden');
            $(this).find('.icon-play').attr('hidden','hidden');
        } else {
            $video.pause();
            $(this).find('.icon-play').removeAttr('hidden');
            $(this).find('.icon-pause').attr('hidden','hidden');
        }

    });
}